/**
 * Normalize the logged-in user id from auth store payloads.
 * Handles string ids, legacy `id`/`userId`, and BSON-like `{ $oid }` shapes.
 */
export function resolveCurrentUserId(user) {
  if (!user || typeof user !== 'object') return '';

  const raw = user._id ?? user.id ?? user.userId;
  if (raw == null || raw === '') return '';

  if (typeof raw === 'string' || typeof raw === 'number') {
    return String(raw);
  }

  if (typeof raw === 'object') {
    if (raw.$oid) return String(raw.$oid);
    if (typeof raw.toString === 'function' && raw.toString() !== '[object Object]') {
      return String(raw.toString());
    }
  }

  return '';
}
